module.exports = __webpack_public_path__ + "img/lg_ring_r_o_0_null@3x.0fc30b40.png";